export default __webpack_public_path__ + "static/media/Snd_TryH.23846c09.mp3";